import { render, staticRenderFns } from "./ConsultantStat.vue?vue&type=template&id=3bc06cbc&scoped=true&"
import script from "./ConsultantStat.vue?vue&type=script&lang=js&"
export * from "./ConsultantStat.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantStat.vue?vue&type=style&index=0&id=3bc06cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc06cbc",
  null
  
)

component.options.__file = "ConsultantStat.vue"
export default component.exports